import { apiClient, type PageData } from './client'
import type {
  CustomerCategory,
  CustomerCategorySavePayload,
  CustomerCategoryType,
} from '@/types/customer-category'

export type {
  CustomerCategory,
  CustomerCategorySavePayload,
  CustomerCategoryType,
} from '@/types/customer-category'

interface CustomerCategoryListParams {
  keyword?: string
  type?: CustomerCategoryType | ''
  page?: number
  page_size?: number
}

function withSearch(path: string, search: URLSearchParams) {
  const query = search.toString()
  return query ? `${path}?${query}` : path
}

export const customerCategoriesApi = {
  list: async (params: CustomerCategoryListParams = {}) => {
    const search = new URLSearchParams()
    if (params.keyword) search.set('keyword', params.keyword)
    if (params.type !== undefined && params.type !== '') search.set('type', String(params.type))
    search.set('page', String(params.page ?? 1))
    search.set('page_size', String(params.page_size ?? 30))
    const response = await apiClient.get<PageData<CustomerCategory>>(
      withSearch('/settings/customer-categories', search),
    )
    return response.data
  },

  options: async () => {
    const response = await apiClient.get<CustomerCategory[]>('/settings/customer-categories/options?module=all')
    return response.data
  },

  create: async (payload: CustomerCategorySavePayload) => {
    const response = await apiClient.post<CustomerCategory>('/settings/customer-categories', payload)
    return response.data
  },

  update: async (id: number, payload: CustomerCategorySavePayload) => {
    const response = await apiClient.put<CustomerCategory>(`/settings/customer-categories/${id}`, payload)
    return response.data
  },

  delete: async (id: number) => {
    await apiClient.delete(`/settings/customer-categories/${id}`)
  },
}
